import { IconHamburgerMenu } from '@odekoteam/doppio';
import { useAppDispatch } from 'src/hooks/store';
import { expandNav } from 'src/state/slices/app';

// Opens the nav: LoggedInContainer's menu row, or a page's own header for
// pages that hide that row on phones. A 44px touch target around the 24px
// icon; callers set margins with sx so the icon lines up with their content.
// theme-ui's JSX runtime turns a caller's sx into this className.
const NavMenuButton = ({
  className,
  id,
}: {
  className?: string;
  id?: string;
}): JSX.Element => {
  const dispatch = useAppDispatch();

  return (
    <button
      type="button"
      id={id}
      className={className}
      aria-label="Open menu"
      onClick={(event): void => {
        // Safari doesn't focus a button on tap or click. Focus it, so closing
        // the menu brings focus back here rather than to the page.
        event.currentTarget.focus();
        dispatch(expandNav());
      }}
      sx={{
        alignItems: 'center',
        backgroundColor: 'transparent',
        border: 0,
        color: 'neutralText',
        cursor: 'pointer',
        display: 'flex',
        flexShrink: 0,
        height: '44px',
        justifyContent: 'center',
        p: 0,
        width: '44px',
        '&:focus-visible': {
          outline: '3px solid',
          outlineColor: 'primaryBackgroundActive',
          outlineOffset: '-3px',
        },
      }}
    >
      <IconHamburgerMenu width={24} height={24} />
    </button>
  );
};

export default NavMenuButton;
